import { Header, SpaceBetween } from '@amzn/awsui-components-console';
import React from 'react';
import { useParams } from 'react-router';

import { useAddActivityToRecentPages } from '../../commons';
import { useInstances, useActivityInfoCache, useGroupName } from 'src/data/redux';
import { dateRangeToStartAndEndDatetimes } from '../instance/InstanceDateRangePicker';
import { fetchInstancesByActivity } from 'src/data/api/fetchFromAPI';
import MonitorInstanceTable from '../instance/MonitorInstanceTable';

/**
 * @returns A simplified component that delegates table rendering to MonitorInstanceTable
 */
export default function MonitorActivity(props: { activityId: string }) {
	const { activityId } = useParams();
	const { activityName } = useActivityInfoCache(activityId)?.data ?? {};

	// Subscribe to store
	const { data, fetching } = useInstances(props.activityId);
	const instances = data || [];
	const groupName = useGroupName();

	useAddActivityToRecentPages(activityId, activityName, groupName);

	const handleRefresh = () => {
		const searchParams = new URLSearchParams(window.location.search);
		const dateRange = JSON.parse(searchParams.get('dateRange') || '{}');
		const instanceStatusId = parseInt(searchParams.get('instanceStatusId')) || -1;
		const [startScheduleDateTime, endScheduleDateTime] = dateRangeToStartAndEndDatetimes(dateRange);

		fetchInstancesByActivity(
			{
				activityId: parseInt(activityId),
				groupName,
				startScheduleDateTime,
				endScheduleDateTime,
				instanceStatusId,
			},
			true
		);
	};

	return (
		<SpaceBetween size="l">
			<Header variant="h2">Monitor Activity</Header>
			<MonitorInstanceTable
				instances={instances}
				loading={fetching}
				showActivityInfo={false}
				onRefresh={handleRefresh}
			/>
		</SpaceBetween>
	);
}
